import * as cx from 'classnames';
import * as React from 'react';
import styles from './Toast.mscss';

interface OwnProps {
    className?: string;
    type: 'success' | 'error' | 'warning';

    remove();
}

const ICONS = {
    success: 'check',
    error: 'exclamation-triangle',
    warning: 'exclamation-triangle',
};

const Toast: React.StatelessComponent<OwnProps> = ({ className, type, children, remove }) => (
    <div className={cx(className, styles.Toast, styles[`Toast--${type}`])}>
        <div className={cx(styles.Toast__icon, styles[`Toast__icon--${type}`])}>
            <i className={cx('fa', `fa-${ICONS[type]}`)} />
        </div>
        <div className={cx(styles.Toast__message, styles[`Toast__message--${type}`])}>
            {children}
        </div>
        <div className={cx(styles.Toast__close, styles[`Toast__close--${type}`])} onClick={remove}>
            <i className="fa fa-times" />
        </div>
    </div>
);

Toast.displayName = 'Toast';

export default Toast;
